var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_257_20559",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.9688,
    y: 0.03125,
    width: 24,
    height: 24,
    transform: "rotate(45 16.9688 0.03125)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_257_20559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7467 14.8798L19.797 19.8296V22.2337C19.797 22.3751 19.7704 22.5077 19.7174 22.6315C19.6644 22.7552 19.5907 22.8642 19.4964 22.9585L19.0898 23.3651C18.8895 23.5654 18.6538 23.6656 18.3827 23.6656C18.1117 23.6656 17.876 23.5654 17.6756 23.3651L14.8472 20.5367L10.7106 24.6732C10.5103 24.8736 10.2746 24.9738 10.0035 24.9738C9.73246 24.9738 9.49676 24.8736 9.29641 24.6732C9.09607 24.4729 8.99589 24.2372 8.99589 23.9661C8.9959 23.6951 9.09607 23.4594 9.29641 23.259L13.433 19.1225L10.6046 16.294C10.4042 16.0937 10.304 15.858 10.304 15.5869C10.304 15.3159 10.4042 15.0802 10.6046 14.8798L11.0111 14.4732C11.1054 14.3789 11.2144 14.3053 11.3382 14.2523C11.4619 14.1992 11.5945 14.1727 11.7359 14.1727L14.1401 14.1727L19.0898 9.22296C18.8895 9.02261 18.7893 8.78691 18.7893 8.51585C18.7893 8.24479 18.8895 8.00909 19.0898 7.80874C19.2902 7.6084 19.5259 7.50822 19.797 7.50822C20.068 7.50822 20.3037 7.6084 20.5041 7.80874L26.1609 13.4656C26.3613 13.6659 26.4614 13.9016 26.4614 14.1727C26.4614 14.4438 26.3613 14.6795 26.1609 14.8798C25.9606 15.0802 25.7249 15.1803 25.4538 15.1803C25.1827 15.1803 24.947 15.0802 24.7467 14.8798Z",
    fill: "#111111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeep);
export default __webpack_public_path__ + "static/media/keep.8888c29c31ac9d085bd1f90116658508.svg";
export { ForwardRef as ReactComponent };